<script setup>
    import { getPrettyPrice, getCashPrice, getCardPrice } from '../shared/utils';
    import useCartStore from '../store/cart';
    import { inject } from 'vue';
    import { useI18n } from 'vue-i18n';
    import iconPlus from '@client/svg/plus.svg?raw';
    import iconMinus from '@client/svg/minus.svg?raw';
    import iconTrash from '@client/svg/trash.svg?raw';

    const cartStore = useCartStore();
    const { t } = useI18n();

    const props = defineProps({
        controls: {
            type: Boolean,
            default: true
        },
        hideCash: {
            type: Boolean,
            default: false,
        }
    })
    let rootData = inject('rootData');
</script>

<template>
    <ul class="line-items">
        <li class="line-item" v-for="lineItem in cartStore.contents" v-bind:key="lineItem.item.id">
            <div class="line-item__inner">
                <dl class="line-item__desc">
                    <dt class="line-item__name">
                        {{ lineItem.name }}
                        <span v-show="lineItem.unitQty > 1" class="line-item__count">{{ t('cart.qty', { qty: lineItem.unitQty }) }}</span>
                    </dt>
                    <dd v-show="lineItem.priceWithModifiers > 0" class="line-item__price">
                        <template v-if="rootData.dualpricing && !props.hideCash">
                            <div v-text="getPrettyPrice(getCardPrice(lineItem.priceWithModifiers * lineItem.unitQty))"></div>
                            <div v-text="getPrettyPrice(getCashPrice(lineItem.priceWithModifiers * lineItem.unitQty))"></div>
                        </template>
                        <template v-else>
                            <div v-text="getPrettyPrice(lineItem.priceWithModifiers * lineItem.unitQty)"></div>
                        </template>
                    </dd>
                </dl>
                <div class="line-item__container">
                    <div class="line-item__mods">
                        {{ lineItem.modifications.map((mod)=> mod.name).join(', ') }}
                    </div>
                    <div v-show="props.controls" class="line-item__actions">
                        <div v-if="lineItem.unitQty > 1" class="action actionSubtract" @click="cartStore.decrease(lineItem._uuidhash)">
                            <div class="iconw" v-html="iconMinus"></div>
                        </div>
                        <div v-else-if="lineItem.unitQty == 1" class="action actionRemove" @click="cartStore.remove(lineItem._uuidhash)">
                            <div class="iconw" v-html="iconTrash"></div>
                        </div>
                        <div class="action actionCounter" v-text="lineItem.unitQty"></div>
                        <div class="action actionAdd" @click="cartStore.increase(lineItem._uuidhash)">
                            <div class="iconw" v-html="iconPlus"></div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
.action {
    z-index: 2;
    width: 2rem;
    height: 2rem;
    overflow: hidden;
    outline: none;
    padding: 0;
    line-height: 1;
    position: relative;
    cursor: pointer;
    flex: 1 0 2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &Remove {
        color: #f04f4f;
        opacity: 0.75;
        filter: grayscale(0.25);
        
        &:hover {
            opacity: 1;
            filter: none;
        }
    }
    &Counter {
        user-select: none;
        cursor: initial;
        text-align: center;
        line-height: 0.77;
        font-size: 0.875rem;
        font-weight: 300;
        align-content: center;
    }
}
.line-item {
    &:not(:last-child) {
        border-bottom: 1px solid #d5d5d5;
    }
    
    &__inner {
        min-height: 48px;
        // margin: 1em .4em;
        padding: 1em .4em;
    }
    &__desc {
        align-items: center;
        color: #333333;
        font-weight: 400;
        display: flex;
        font-size: 1rem;
        margin: 0;
        line-height: 1.1;
    }
    &__name {
        width: 65%;
        font-weight: 400;
    }
    &__price {
        margin: 0;
        text-align: right;
        width: 35%;
        font-weight: 500;
        font-size: 1rem;
        font-size: 0.875em;
        display: flex;
        justify-content: flex-end;

        div {
        position: relative;
        padding-left: .375rem;
        padding-right: .375rem;

        &:first-child {
          padding-left: 0;
          &:not(:last-child) {
            padding-right: .375rem;
  
            &::after {
              content: "";
              width: 1px;
              height: 100%;
              background-color: currentColor;
              position: absolute;
              opacity: 0.75;
              right: 0;
              transform-origin: center;
              transform: translate3d(-50%,-1px,0);
              top: 0;
            }
          }
        }
        
      }

    }
    &__count {
        font-weight: 300;
        font-size: 0.875em;
    }
    &__container {
        display: flex;
        flex-direction: row;
        margin-top: .2em;
    }
    &__mods {
        color: #555555;
        padding: 2px 0;
        font-size: 0.75rem;
        line-height: 0.875rem;
        flex-grow: 1;
        margin: 0 60px 0 0;
        // flex: 0 1 calc(100% - 1.25rem);
        flex: 0 1 calc(100% - 6.75rem);
    }
    &__actions {
        display: flex;
        justify-content: space-between;
        margin-top: 0.75rem;
        height: 2rem;
        border: 1px solid #eee;
        border-radius: 2px;
        &>div:first-child {
            border-right: 1px solid #eee;
        }
        &>div:last-child {
            border-left: 1px solid #eee;
        }
    }
}
</style>